var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('FormExpenseFilters',{attrs:{"default":_vm.filters},on:{"update":_vm.handleFilters,"load":_vm.loadData}}),(_vm.formExpenseData.length > 0)?_c('FormExpenseTable',{attrs:{"form-expense-data":_vm.formExpenseData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }